
import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Subscription} from "rxjs";
import {CascadingJSONService} from "../../shared/services/cascading-json.service";
import {isUndefined} from "util";
import {isArray} from "util";


@Component({
  selector: 'cascading-type',
  templateUrl: './cascading-type.component.html',
  styleUrls: ['./cascading-type.component.css']
})
export class CascadingTypeComponent implements OnInit{

  //Self explanatory

  @Input() question_index: number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() cascad : any;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() userRes : string[];
  @Input() indexOfRepeater : number;
  @Input() question_number : number;
  
  map_cord : string;
  subscription : Subscription;
  cascading : any;
  numOfChild : number;
  level0 = [];
  level0_Selected = "";
  level1 = [];
  level1_Selected = "";
  level2 = [];
  level2_Selected = "";
  level3 = [];
  level3_Selected = "";
  level4 = [];
  level4_Selected = "";
  response:string;

  ngOnInit(){

    if(!isUndefined(this.cascad)){
      this.cascading = JSON.parse(this.cascad);
      this.level0 = Object.keys(this.cascading);

      let key1 = this.level0[0];
      let keys2 = [];

      if(isArray(this.cascading[key1])){
        this.numOfChild = 2;
      }else{

        keys2 = Object.keys(this.cascading[key1]);
        let key2 = keys2[0];
        let keys3 = [];

        if(isArray(this.cascading[key1][key2])){
          this.numOfChild = 3;
        }else{

          keys3 = Object.keys(this.cascading[key1][key2]);
          let key3 = keys3[0];

          if(isArray(this.cascading[key1][key2][key3])){
            this.numOfChild = 4;
          }else{
            this.numOfChild = 5;
          }

        }

      }
    }
  }



  clickedLevel0(i : number){
    this.level0_Selected = this.level0[i];
    if(isArray(this.cascading[this.level0_Selected])){
      this.level1 = this.cascading[this.level0_Selected];
    }else{
      this.level1 = Object.keys(this.cascading[this.level0_Selected]);
    }
    if(this.numOfChild == 1)
    {
      this.response = "[" +  this.level0_Selected + "]";
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }
    this.level1_Selected = "";
    this.level2 = [];
    this.level2_Selected = "";
    this.level3 = [];
    this.level3_Selected = "";
    this.level4 = [];
    this.level4_Selected = "";
  }


  clickedLevel1(i : number){
    this.level1_Selected = this.level1[i];
    if(isArray(this.cascading[this.level0_Selected][this.level1_Selected])){
      this.level2 = this.cascading[this.level0_Selected][this.level1_Selected];
    }else if(this.numOfChild > 2){
      this.level2 = Object.keys(this.cascading[this.level0_Selected][this.level1_Selected]);
    }
    if(this.numOfChild == 2)
    {
      this.response = "[" +  this.level0_Selected + " , "+  this.level1_Selected + "]";
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }

    this.level2_Selected = "";
    this.level3 = [];
    this.level3_Selected = "";
    this.level4 = [];
    this.level4_Selected = "";
  }

  clickedLevel2(i : number){
    this.level2_Selected = this.level2[i];

    if(isArray(this.cascading[this.level0_Selected][this.level1_Selected][this.level2_Selected])){
      this.level3 = this.cascading[this.level0_Selected][this.level1_Selected][this.level2_Selected];
    }else if(this.numOfChild > 3){
      this.level3 = Object.keys(this.cascading[this.level0_Selected][this.level1_Selected][this.level2_Selected]);
    }
    if(this.numOfChild == 3)
    {
      this.response = "[" +  this.level0_Selected + " , "+  this.level1_Selected + " , "+  this.level2_Selected  + "]";
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }

    this.level3_Selected = "";
    this.level4 = [];
    this.level4_Selected = "";
  }

  clickedLevel3(i : number){
    this.level3_Selected = this.level3[i];
    if(isArray(this.cascading[this.level0_Selected][this.level1_Selected][this.level2_Selected][this.level3_Selected])){
      this.level4 = this.cascading[this.level0_Selected][this.level1_Selected][this.level2_Selected][this.level3_Selected];
    }
    
    if(this.numOfChild == 4)
    {
      this.response = "[" +  (this.level0_Selected).toString() + " , "+  (this.level1_Selected ).toString() + " , "+  (this.level2_Selected).toString() + " , " +  (this.level3_Selected).toString()  + "]";
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }
    
    this.level4_Selected = "";
  }

  clickedLevel4(i : number){
    this.level4_Selected = this.level4[i];
  }




}



// WEBPACK FOOTER //
// ./src/app/questions-type/cascading-type/cascading-type.component.ts